import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import DoneIcon from '@material-ui/icons/Done';
import { green } from '@material-ui/core/colors';

import EditIcon from '@material-ui/icons/Edit';
import UnifiedEditServices from './UnifiedEditServices';
import { formatPrice } from '../../helper';

const useStyles = makeStyles(() => ({
  actionEdit: {
    textAlign: 'right',
    position: 'relative',
  },
  serviceList: {
    color: '#212B36',
    marginBottom: 5,
  },
  listLabel: {
    fontWeight: '500',
    color: '#000',
  },
  bookedRow: {
    '& .MuiTableCell-root': {
      borderBottom: 'none',
    },
  },
  iconSuccess: {
    color: green[500],
    marginRight: 5,
  },
  pointer: {
    cursor: 'pointer',
  },
  titleBox: {
    marginTop: 24,
    marginBottom: 24,
    '& h5': {
      fontWeight: 700,
    },
  },
  serviceIconMargin: {
    marginRight: 16,
  },
  editIconStyle: {
    color: '#637381',
    width: 16.67,
    height: 16.67,
    pointer: 'pointer',
  },
  table: {
    whiteSpace: 'nowrap',
  },
}));

const UnifiedServices = (props) => {
  const { record, isPaidOrHeld } = props;
  const { services, st_order_id, other_service_description } = record;

  const [editServices, setEditServices] = useState(false);
  const classes = useStyles();

  const handleEdit = () => {
    setEditServices((prev) => !prev);
  };

  const checkEditButton = (services = []) => {

    if (!Array.isArray(services) || services.length === 0) return null;
    if (services.length === 1) {
      if (services[0]?.display_name?.replace(/\s+/g, ' ').trim() === "New Tire Installation") {
        const status = services[0]?.service_payment_status;
        if (status === 'PaidInstall') {
          return true;
        }
        if (status === 'PayAtShop') {
          return false;
        }
      }
      if (services[0]?.display_name === "Tire Pick Up") {
        return true;
      }
    }
    // else {
    //     const allArePayAtShop = services.every(
    //         service => service?.service_payment_status === 'PayAtShop'
    //     );
    //     if (allArePayAtShop) {
    //         return "Customer has declined to pay online for services.";
    //     }
    // }

    return null;
  };

  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs={10} sm={10} md={10} className={classes.titleBox}>
          <Typography variant="h5" gutterBottom>
            Services
          </Typography>
        </Grid>
        <Grid item xs={2} sm={2} md={2} className={classes.actionEdit}>
          {!editServices && !isPaidOrHeld && record.status !== 'cancelled' && !checkEditButton(services) && (
            <EditIcon
              fontSize="inherit"
              onClick={handleEdit}
              className={classes.editIconStyle}
            />
          )}
        </Grid>
      </Grid>
      <TableContainer component={Paper}>
        <Table
          className={`service_table ${classes.table}`}
          aria-label="simple table"
        >
          {!editServices && (
            <TableHead>
              <TableRow>
                <TableCell>Service</TableCell>
                <TableCell align="right">Service Duration (Hours)</TableCell>
                <TableCell align="right">Labor Charge</TableCell>
                <TableCell align="right">Parts Charge</TableCell>
                <TableCell align="right">Discount</TableCell>
                <TableCell align="right">Total</TableCell>
              </TableRow>
            </TableHead>
          )}
          <TableBody>
            {editServices ? (
              <UnifiedEditServices
                {...props}
                setEditServices={setEditServices}
              />
            ) : (
              <>
                {services && services.length > 0 && (
                  <>
                    {services
                      .slice() // create a shallow copy to avoid mutating original array
                      .sort((a, b) => {
                        if (a.display_name === 'Other') return 1;
                        if (b.display_name === 'Other') return -1;
                        return 0;
                      })
                      .map((service, i) => (
                        <ServiceDetail
                          key={service.id}
                          service={service}
                          index={i}
                          heading="Pre-booked Services"
                          totalCount={services.length}
                          record={record}
                          st_order_id={st_order_id}
                          description={
                            service.display_name === 'Other'
                              ? other_service_description
                              : ''
                          }
                        />
                      ))}
                  </>
                )}
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default UnifiedServices;


const renderPayAtShop = (service_payment_status) => {

  if (service_payment_status === 'PayAtShop') {
    return (
      <div
        className="description"
        style={{
          backgroundColor: '#FFF7E0',
          color: '#C27C00',
          padding: '2px 10px',
          fontSize: '12px',
          borderRadius: '8px',
          fontWeight: 600,
          display: 'inline-block',
          fontFamily: 'sans-serif',
          padding: '4px 8px',
          wordWrap: 'break-word',
          marginTop: '5px',
          marginBottom: '5px'
        }}
      >
        Pay at shop
      </div>
    );
  }
  else if (service_payment_status === 'PaidInstall') {
    return (
      <div
        className="description"
        style={{
          backgroundColor: '#22C55E29',
          color: '#118D57',
          padding: '2px 10px',
          fontSize: '12px',
          borderRadius: '8px',
          fontWeight: 600,
          display: 'inline-block',
          fontFamily: 'sans-serif',
          padding: '4px 8px',
          wordWrap: 'break-word',
          marginTop: '5px',
          marginBottom: '5px'
        }}
      >
        Prepaid online
      </div>

    );
  }
  else if (service_payment_status === 'NoInstallPickup') {
    return (
      <div
        className="description"
        style={{
          backgroundColor: '#22C55E29',
          color: '#118D57',
          padding: '2px 10px',
          fontSize: '12px',
          borderRadius: '8px',
          fontWeight: 600,
          display: 'inline-block',
          fontFamily: 'sans-serif',
          padding: '4px 8px',
          wordWrap: 'break-word',
          marginTop: '5px',
          marginBottom: '5px'
        }}
      >
        No Install Pickup
      </div>
    );
  }
  else {
    return (
      <div
        className="description"
        style={{
          backgroundColor: '#22C55E29',
          color: '#118D57',
          padding: '2px 10px',
          fontSize: '12px',
          borderRadius: '8px',
          fontWeight: 600,
          display: 'inline-block',
          fontFamily: 'sans-serif',
          padding: '4px 8px',
          wordWrap: 'break-word',
          marginTop: '5px',
          marginBottom: '5px'
        }}
      >
        {service_payment_status === 'PaidServices'
          ? "Prepaid online"
          : service_payment_status}

      </div>
    );
  }

  // return (
  //   <div
  //     className="description"
  //     style={{
  //       backgroundColor: '#22C55E29',   //FFF7E0   // light yellow
  //       color: '#118D57',     //C27C00          // dark gold
  //       padding: '2px 10px',
  //       fontSize: '12px',
  //       borderRadius: '8px',
  //       fontWeight: 600,
  //       display: 'inline-block',
  //       fontFamily: 'sans-serif',
  //       padding: '4px 8px',
  //       wordWrap: 'break-word',
  //       marginTop: '5px',
  //       marginBottom: '5px'
  //     }}
  //   >
  //     Pay at shop
  //   </div>
  // )
}

function IconDisplayServices({ iconUrl }) {
  return (
    <img
      src={iconUrl}
      //alt="Dynamic Icon"
      style={{ width: 24, height: 24, paddingRight: 10 }}
      onError={<svg
        className="tool_icon"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M21.6886 18.6685L16.3886 13.3685H15.3986L12.8586 15.9085V16.8985L18.1586 22.1985C18.5486 22.5885 19.1786 22.5885 19.5686 22.1985L21.6886 20.0785C22.0786 19.6985 22.0786 19.0585 21.6886 18.6685ZM18.8586 20.0885L14.6186 15.8485L15.3286 15.1385L19.5686 19.3785L18.8586 20.0885Z"
          fill="black"
        />
        <path
          d="M17.3586 10.6885L18.7686 9.27853L20.8886 11.3985C22.0586 10.2285 22.0586 8.32854 20.8886 7.15854L17.3486 3.61854L15.9386 5.02854V2.20854L15.2386 1.49854L11.6986 5.03854L12.4086 5.74854H15.2386L13.8286 7.15854L14.8886 8.21853L11.9986 11.1085L7.86855 6.97854V5.55854L4.84855 2.53854L2.01855 5.36854L5.04855 8.39854H6.45855L10.5886 12.5285L9.73855 13.3785H7.61855L2.31855 18.6785C1.92855 19.0685 1.92855 19.6985 2.31855 20.0885L4.43855 22.2085C4.82855 22.5985 5.45855 22.5985 5.84855 22.2085L11.1486 16.9085V14.7885L16.2986 9.63854L17.3586 10.6885ZM9.37855 15.8385L5.13855 20.0785L4.42855 19.3685L8.66855 15.1285L9.37855 15.8385Z"
          fill="black"
        />
      </svg>} // hides if broken
    />
  );
}

const ServiceDetail = ({
  service,
  index,
  totalCount,
  st_order_id,
  description,
}) => {
  const classes = useStyles();
  const {
    display_name,
    status,
    labor_cost_dollars,
    labor_hours,
    parts_cost_dollars,
    total_cost_dollars,
    service_payment_status,
    card_image_url,
    coupon_amount_dollars,
    coupon_code
  } = service;

  let sourceImg = (
    <svg
      className="tool_icon"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21.6886 18.6685L16.3886 13.3685H15.3986L12.8586 15.9085V16.8985L18.1586 22.1985C18.5486 22.5885 19.1786 22.5885 19.5686 22.1985L21.6886 20.0785C22.0786 19.6985 22.0786 19.0585 21.6886 18.6685ZM18.8586 20.0885L14.6186 15.8485L15.3286 15.1385L19.5686 19.3785L18.8586 20.0885Z"
        fill="black"
      />
      <path
        d="M17.3586 10.6885L18.7686 9.27853L20.8886 11.3985C22.0586 10.2285 22.0586 8.32854 20.8886 7.15854L17.3486 3.61854L15.9386 5.02854V2.20854L15.2386 1.49854L11.6986 5.03854L12.4086 5.74854H15.2386L13.8286 7.15854L14.8886 8.21853L11.9986 11.1085L7.86855 6.97854V5.55854L4.84855 2.53854L2.01855 5.36854L5.04855 8.39854H6.45855L10.5886 12.5285L9.73855 13.3785H7.61855L2.31855 18.6785C1.92855 19.0685 1.92855 19.6985 2.31855 20.0885L4.43855 22.2085C4.82855 22.5985 5.45855 22.5985 5.84855 22.2085L11.1486 16.9085V14.7885L16.2986 9.63854L17.3586 10.6885ZM9.37855 15.8385L5.13855 20.0785L4.42855 19.3685L8.66855 15.1285L9.37855 15.8385Z"
        fill="black"
      />
    </svg>
  );
  let imgClass = 'tool_icon_box';
  // This conditional block handles status for ScheduledWorks and Services
  if (st_order_id > 0) {
    sourceImg = (
      <svg
        className="st_icon"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M13.3019 17.4409V11.2601H18.486C18.4895 11.3407 18.4907 11.4212 18.4907 11.5018C18.4907 14.5039 16.2662 17.0416 13.3019 17.4409ZM19.7817 9.70808L19.7675 9.6524L6.79254 9.65003C7.59618 7.168 9.87491 5.50699 12.4959 5.50699C14.4595 5.50699 16.2674 6.4536 17.392 8.04944H19.1468C17.8499 5.54846 15.321 4 12.4959 4C8.4659 4 5.17347 7.15023 5 11.1866V11.2601H11.6922V17.4409C9.21525 17.1092 7.23035 15.2894 6.66745 12.863H5.12509C5.77885 16.4291 8.84234 19 12.4959 19C16.6309 19 19.9976 15.6365 20 11.5018C20 10.8928 19.9268 10.2898 19.7817 9.70808Z"
          fill="#181818"
        />
      </svg>
    );
    imgClass = 'st_icon_box';
  }
  return (
    <>
      <TableRow
        className={index < totalCount - 1 ? `${classes.bookedRow}` : ''}
      >
        <TableCell component="th" scope="row">
          <Box>
            <Box display="flex" alignItems="center">
              {status === 'COMPLETE' && (
                <DoneIcon className={classes.iconSuccess} />
              )}
              {/* <Box className={`${imgClass} ${classes.serviceIconMargin}`}>
                {sourceImg}
              </Box> */}
              <IconDisplayServices iconUrl={card_image_url} />
              <Typography
                variant="body1"
                gutterBottom
                className={classes.listLabel}
              >
                <div>
                  {display_name}
                  <div>{renderPayAtShop(service_payment_status)}</div>
                  {description && (
                    <div
                      className="description"
                      style={{
                        width: '255px',
                        wordWrap: 'break-word',
                        fontSize: '14px',
                        color: '#666',
                        backgroundColor: '#f9f9f9',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        whiteSpace: 'normal',
                        fontStyle: 'italic',
                      }}
                    >
                      {description}
                    </div>
                  )}
                </div>
              </Typography>
            </Box>
          </Box>
        </TableCell>
        <TableCell align="right">
          <Box>
            <Typography variant="body2" className={classes.serviceList}>
              {labor_hours || '-'}
            </Typography>
          </Box>
        </TableCell>
        <TableCell align="right">
          <Box>
            <Typography variant="body2" className={classes.serviceList}>
              {formatPrice(labor_cost_dollars) || '-'}
            </Typography>
          </Box>
        </TableCell>
        <TableCell align="right">
          <Box>
            <Typography variant="body2" className={classes.serviceList}>
              {formatPrice(parts_cost_dollars) || '-'}
            </Typography>
          </Box>
        </TableCell>
        <TableCell align="right">
          <Box>
            <Typography variant="body2" className={classes.serviceList}>
              {formatPrice(coupon_amount_dollars) || '-'}
            </Typography>
            {coupon_code && (
              <Typography variant="caption" color="textSecondary" display="block" style={{ fontSize: '11px', marginTop: '-4px' }}>
                ({coupon_code})
              </Typography>
            )}
          </Box>
        </TableCell>
        <TableCell align="right">
          <Box>
            <Typography variant="body2" className={classes.serviceList}>
              {formatPrice(total_cost_dollars) || '-'}
            </Typography>
          </Box>
        </TableCell>
      </TableRow>
    </>
  );
};
